// Helper function to check if URL is a YouTube video
export const isYouTubeUrl = (url: string): boolean => {
    const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/.+/;
    return youtubeRegex.test(url);
};

// Helper function to extract YouTube video ID
export const getYouTubeVideoId = (url: string): string | null => {
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=|embed\/|v\/)?([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
};

// Helper function to determine media type
export const getMediaType = (url: string): 'image' | 'gif' | 'youtube' => {
    if (isYouTubeUrl(url)) {
        return 'youtube';
    }
    if (url.toLowerCase().endsWith('.gif')) {
        return 'gif';
    }
    return 'image';
};

// Generate YouTube thumbnail URL
export const getYouTubeThumbnail = (videoId: string): string => {
    return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
};

// Generate YouTube embed URL
export const getYouTubeEmbedUrl = (videoId: string): string => {
    return `https://www.youtube.com/embed/${videoId}?autoplay=0&rel=0&modestbranding=1`;
}; 